export default __webpack_public_path__ + "static/media/BoschSans-Regular.1918930b.woff2";